import { render, staticRenderFns } from "./suggest.vue?vue&type=template&id=23a56e9f&scoped=true"
import script from "./suggest.vue?vue&type=script&lang=js"
export * from "./suggest.vue?vue&type=script&lang=js"
import style0 from "./suggest.vue?vue&type=style&index=0&id=23a56e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a56e9f",
  null
  
)

export default component.exports